<template>
  <router-link
    class="card"
    :to="{
      name: 'news-item',
      params: { homeSlug: $route.params.homeSlug, slug: item.slug },
    }"
  >
    <div
      class="image"
      :style="{ backgroundImage: `url(${item.card.image.url})` }"
    />
    <div class="content" :style="{ backgroundColor: colour }">
      <p class="text -semibold -t3 -white title">{{ item.title }}</p>
      <div class="text -t4 -white text" v-html="item.card.text" />
      <span class="text -regular -t4 -white link">Read more ></span>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    item: Object,
    colour: String,
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.card {
  padding: vw-relative(0 0 20, 320);
  height: 100%;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  @include breakpoint(medium) {
    padding: vw-relative(0 13 26);
  }
}
.image {
  padding-top: 75%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #f7f7f7;
}
.content {
  flex-grow: 1;
  padding: vw-relative(15, 320);
  @include breakpoint(medium) {
    padding: vw-relative(25);
  }
}
.title {
  margin-bottom: 0.7em;
}
.text {
  margin-bottom: 0.7em;
}
.link {
  text-decoration: none;
}
</style>
